<template>
    <div class="timeline-carusel my-5">
        <div class="container px-3 m-auto">
            <div class="owl-carousel owl-theme">

                <template v-for="timeline in options.timeline">
                    <div class="item" _style="max-width:310px; min-height:150px;">
                        <div class="flex flex-row justify-start items-start mr-10 text-nandor">
                            <h4 class="whitespace-nowrap pt-16 font-bold text-sm leading-tight ">
                                <span v-html="timeline.alt"></span>
                            </h4>
                            <div class="h-0 pb-32 mx-2 border-r border-nandor w-1"></div>
                            <p class=" pt-16 text-sm leading-tight">
                                <span v-html="timeline.text"></span>
                            </p>
                        </div>
                    </div>
                </template>


            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TimelineCarousel",
    props: {
        options: null,
    },
    mounted() {


        $('.owl-carousel').owlCarousel({
            nav: true,
            dots: false,
            margin: 10,
            loop: false,
            autoWidth: false,
            items: 1,
            responsive : {
                768 : {
                    items: 2,
                },
                1024 : {
                    items: 3,
                }
            }
        });

        function setWidth(t) {
            let sto = setTimeout(function () {
                clearTimeout(sto);

                let totalWidth = 0;
                let olwItems = $('.owl-carousel .owl-item');
                $.each(olwItems, function (idx, item) {
                    totalWidth += $(item).outerWidth() + 30;

                })
                $('.owl-stage').width(totalWidth);

                console.log( totalWidth);
            }, t || 300);
        }

        setWidth(100);
        setWidth(500);
        setWidth(1000);
        setWidth(2000);


    }
}
</script>

<style scoped lang="scss">
.timeline-carusel {
    min-height: 150px;
    background-image: url('@/assets/images/commons/portativ.jpg');
    background-size: auto;
    background-repeat: repeat-x;
    background-position: top left;


    .item {
        max-width: 300px;
        min-height: 150px;

        @media(min-width: 768px) {
            max-width: 480px;
        }


    }


    ::v-deep .owl-carousel {

        .owl-stage{
            //display:flex;

            .owl-item{
                width:250px;
                display: inline-block;
            }
        }

        .owl-nav {
            pointer-events: none;
            position: absolute;
            width: 100%;
            top: 5px;
            left: 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            pointer-events: none;

            button {
                width: 25px;
                height: 25px;
                display: block;
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
                content: "";
                cursor: pointer;
                pointer-events: auto;

                &:hover {
                    background-color: transparent !important;
                }

                span {
                    display: none;
                }

                &.disabled {
                    visibility: hidden;
                }


                &.owl-prev {
                    background-image: url('@/assets/images/commons/btnArrowPrevious.png');
                }

                &.owl-next {
                    background-image: url('@/assets/images/commons/btnArrowNext.png');
                }
            }


        }
    }


}
</style>
